import { Note } from './Note';

export type Interval = (note: Note) => Note;

const steps = (note: Note, n: number): Note => (note + n) % 12;

export const unison: Interval = note => note;
export const min2: Interval = note => steps(note, 1);
export const maj2: Interval = note => steps(note, 2);
export const min3: Interval = note => steps(note, 3);
export const maj3: Interval = note => steps(note, 4);
export const perf4: Interval = note => steps(note, 5);
export const aug4: Interval = note => steps(note, 6);
export const dim5: Interval = aug4;
export const perf5: Interval = note => steps(note, 7);
export const aug5: Interval = note => steps(note, 8);
export const min6: Interval = aug5;
export const maj6: Interval = note => steps(note, 9);
export const min7: Interval = note => steps(note, 10);
export const maj7: Interval = note => steps(note, 11);
